import React from 'react';
import './AimsObjective.css';
import { useEffect } from 'react';
function AimsObjective() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
  return (
    <div className="ao-container">
      <div className="ao-section">
        <h2 className="ao-heading">Aims</h2>
        <ul className="ao-list">
          <li>The basic aim is that schools are the betterment of societies.</li>
          <li>To provide an efficient life for the school children and prepare them for the art of learning together.</li>
          <li>To bring school and community close to each other.</li>
          <li>To prepare the students according to their interests and abilities.</li>
          <li>To help the students unfold their personality (mental development) and inner self.</li>
          <li>To guide the students to have the right type of psychology for life.</li>
          <li>To conserve all the group practical values, heredity, and culture of society.</li>
          <li>To teach them thinking skills, to make decisions and choices.</li>
        </ul>
      </div>

      <div className="ao-section">
        <h2 className="ao-heading">Objectives</h2>
        <ul className="ao-list">
          <li>
            <strong>Academic Excellence:</strong>
            <ul>
              <li>Provide a well-structured curriculum that meets the highest standards of education.</li>
              <li>Encourage analytical thinking, problem-solving, and innovative approaches to learning.</li>
            </ul>
          </li>
          <li>
            <strong>Personal Development:</strong>
            <ul>
              <li>Cultivate self-discipline, resilience, and a growth mindset among students.</li>
              <li>Support emotional well-being and character building through value-based education.</li>
            </ul>
          </li>
          <li>
            <strong>Community Engagement:</strong>
            <ul>
              <li>Strengthen partnerships with parents and local communities to enhance the educational experience.</li>
              <li>Encourage students to engage in community service and develop a sense of social responsibility.</li>
            </ul>
          </li>
          <li>
            <strong>Inclusivity and Equity:</strong>
            <ul>
              <li>Ensure that every child, regardless of background, has access to quality education and resources.</li>
              <li>Promote an inclusive environment where diversity is celebrated and respected.</li>
            </ul>
          </li>
          <li>
            <strong>Skill Development:</strong>
            <ul>
              <li>Focus on equipping students with 21st-century skills like communication, collaboration, and digital literacy.</li>
              <li>Offer opportunities for hands-on learning, practical applications, and leadership development.</li>
            </ul>
          </li>
          <li>
            <strong>Environmental Stewardship:</strong>
            <ul>
              <li>Instill an awareness of environmental conservation and sustainability among students.</li>
              <li>Incorporate eco-friendly practices and projects into the school’s activities.</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default AimsObjective;
